export default __webpack_public_path__ + "static/media/js.638082e9e19161d42f2bc2eb803cee11.svg";